import { render, staticRenderFns } from "./ReportSupportTicket.vue?vue&type=template&id=590a0cc6&"
import script from "./ReportSupportTicket.vue?vue&type=script&lang=js&"
export * from "./ReportSupportTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports